import type { RouteObject } from "react-router-dom";

import { path } from "./path";

import { ErrorPage } from "@pages/errorPage";
import { useUIStore } from "@/stores/uiStore";

export const guestJoinRoutes: RouteObject[] = [
  {
    path: path.join.route,
    lazy: () =>
      import(
        "@components/organisms/videoVisit/pages/guestJoinPage/guestJoinPage"
      ),
    loader: (props) => {
      useUIStore
        .getState()
        .setPage(props?.request, "pageTitle.guestJoin", [], "edit");
      return null;
    },
    errorElement: <ErrorPage />,
  },
];
